const endodontics = {
  hero: {
    badgeIconAlt: "Икона Ендодонтия",
    badgeText: "Съвременно Лечение на Коренови Канали",
    titleLine1: "Модерна Ендодонтска",
    titleLine2: "Грижа и Лечение",
    description:
      "Нашите експертни ендодонтски процедури запазват естествените ви зъби чрез съвременно лечение на коренови канали с минимална болка, използвайки най-новите технологии и техники.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете за Процеса",
    },
    heroImageAlt: "Модерно Ендодонтско Лечение",
    stats: {
      successRateLabel: "Успеваемост",
      successRateValue: "95%+",
      painFreeLabel: "Без Болка",
      painFreeValue: "Съвременно",
    },
    experience: {
      label: "Експертни Специалисти",
      value: "15+ Години Опит",
    },
  },
  benefits: {
    heading: "ЗАЩО ДА ИЗБЕРЕТЕ ЕНДОДОНТСКО ЛЕЧЕНИЕ",
    intro:
      "Модерното лечение на коренови канали запазва естествените ви зъби с комфорт и прецизност.",
    items: [
      {
        title: "Запазете Естествените си Зъби",
        description:
          "Ендодонтското лечение ви помага да запазите естествената си усмивка, да продължите да се наслаждавате на любимите си храни и ограничава нуждата от допълнителна дентална работа.",
      },
      {
        title: "Практически Безболезнено",
        description:
          "С модерните техники и анестезия, пациентите споделят, че лечението на кореновия канал е толкова комфортно, колкото поставянето на пломба.",
      },
      {
        title: "Ефективно и Бързо",
        description:
          "Нашите ендодонтски процедури се извършват само в 1-2 посещения, осигурявайки бързо облекчение от болката с отлични дългосрочни резултати.",
      },
    ],
  },
  process: {
    heading: "ПРОЦЕС НА ЛЕЧЕНИЕ",
    intro:
      "Следваме прецизен, методичен подход, за да осигурим най-добрите възможни резултати от нашите ендодонтски лечения.",
    steps: [
      {
        title: "Диагностика и Преглед",
        description:
          "Нашите специалисти правят дигитални рентгенови снимки и извършват тестове, за да идентифицират източника на болката и да определят дали е необходимо лечение на кореновия канал.",
      },
      {
        title: "Подготовка и Анестезия",
        description:
          "Прилагаме локална анестезия, за да обезболим напълно зоната, гарантирайки, че няма да изпитвате болка по време на процедурата.",
      },
      {
        title: "Премахване на Пулпата и Почистване",
        description:
          "Инфектираната пулпа се отстранява внимателно, а каналите се почистват и оформят щателно със специализирани инструменти.",
      },
      {
        title: "Запълване и Запечатване на Канала",
        description:
          "Почистените канали се запълват с биосъвместим материал и се запечатват, за да се предотврати повторна инфекция.",
      },
      {
        title: "Финална Реставрация",
        description:
          "Поставя се корона или друга реставрация за защита на зъба и възстановяване на пълната му функция и външен вид.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro:
      "Намерете отговори на често задавани въпроси за ендодонтско лечение",
    items: [
      {
        question: "Болезнено ли е лечението на коренов канал?",
        answer:
          "С модерните техники и анестезия, процедурата за лечение на коренов канал се усеща подобно на поставянето на пломба. Повечето пациенти споделят, че се чувстват комфортно по време на процедурата и изпитват само лек дискомфорт след това, който може да се овладее с обикновени болкоуспокояващи.",
      },
      {
        question: "Колко време отнема процедурата за коренов канал?",
        answer:
          "Повечето лечения на коренови канали могат да бъдат завършени в рамките на един час до час и половина. По-сложните случаи може да изискват две посещения. Използването на съвременни технологии ни помага да осигурим ефективност без компромис с качеството.",
      },
      {
        question: "Колко дълго ще издържи лекуваният зъб?",
        answer:
          "При правилна грижа, зъб, който е преминал лечение на коренов канал, може да издържи цял живот. Процентът на успеваемост при лечението на коренови канали е много висок и много зъби с коренови канали могат да издържат толкова дълго, колкото и другите естествени зъби.",
      },
      {
        question: "Какво се случва, ако не направя лечение на коренов канал?",
        answer:
          "Ако се нуждаете от лечение на коренов канал, но не го направите, инфекцията ще продължи да се разпространява, което потенциално може да доведе до образуване на абсцес, загуба на костна тъкан и евентуално загуба на зъба. Инфекцията може също да се разпространи към други части на тялото, създавайки сериозни рискове за здравето.",
      },
      {
        question: "Необходима ли е корона след лечение на коренов канал?",
        answer:
          "В повечето случаи, да. Короната помага за защита на лекувания зъб от счупване и възстановява пълната му функционалност. Задните зъби (кътници и предкътници) почти винаги се нуждаят от корони, докато предните зъби може да не се нуждаят, ако са все още структурно здрави.",
      },
      {
        question: "Как да се грижа за зъба си след лечение на коренов канал?",
        answer:
          "След поставянето на финалната реставрация, трябва да се грижите за лекувания зъб както за естествените си зъби: четкане два пъти дневно, използване на конец за зъби ежедневно, използване на антимикробна вода за уста и редовни посещения при зъболекар за прегледи и почистване.",
      },
    ],
  },
};

export default endodontics;

